import { getCountryCode } from '@/helpers/CountryCodeHelper';
import { HomePageLink } from '@/helpers/DocumentHelper';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IdleTimeOutModal } from './Modal';

type Props = {
  timeOutInterval?: number;
  onIdle: () => void;
  onActive: () => void;
};

const IdleTimeOutHandler = (props: Props) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  let timer: string | number | NodeJS.Timeout | undefined;
  let lastInteractionTime: number;

  const events = ['load', 'click', 'scroll', 'load', 'keydown'];

  const addEventListeners = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });
  };

  const removeEventListeners = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  const eventHandler = () => {
    lastInteractionTime = new Date().getTime();
    clearTimeout(timer);
    props.onActive();
    startTimer();
  };

  useEffect(() => {
    addEventListeners();
    return () => {
      removeEventListeners();
      clearTimeout(timer);
    };
  }, []);

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(
      () => {
        const now = new Date().getTime();
        const idleTime = now - lastInteractionTime;
        let timeOutInterval = props.timeOutInterval
          ? props.timeOutInterval
          : 900000;
        if (idleTime > timeOutInterval) {
          props.onIdle();
          setShowModal(true);
        } else {
          startTimer();
        }
      },
      props.timeOutInterval ? props.timeOutInterval : 900000,
    );
  };

  const handleRedirect = () => {
    removeEventListeners();
    clearTimeout(timer);
    setShowModal(false);
    window.location.href = t(HomePageLink[getCountryCode()]);
  };

  const handleRefresh = () => {
    setShowModal(false);
    window.location.reload();
  };

  return (
    <div>
      <IdleTimeOutModal
        showModal={showModal}
        handleRedirect={handleRedirect}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default IdleTimeOutHandler;
